import useStore from "@/store/zustandStore";
import { useShallow } from "zustand/react/shallow";

// 인증 상태만 (primitive 값이라 안전)
export const useAuthentication = () =>
  useStore((state) => state.authentication);

// 유저 정보만
export const useUser = () => useStore((state) => state.user);

// 액션만 (함수 참조는 안정적)
export const useAuthActions = () =>
  useStore(
    useShallow((state) => ({
      setAuth: state.setAuth,
      removeAuth: state.removeAuth,
    }))
  );
